import request from '@/utils/request'
const BASE_URL = '/School'

//学生信息
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data: { ...data, SortName: "Sn", SortOrder: "ASC" }
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  }
}